// extracted by mini-css-extract-plugin
export default {"menuBlock":"lJ-z","title":"mJ-z","nav":"nJ-z","flexCell":"oJ-z","facetLink":"pJ-z"};